var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',[(!_vm.showTwoFactor)?_c('LoginForm',{on:{"TwoFactorRequired":_vm.onShowTwoFactor,"LoginSuccess":_vm.loginSuccess}}):_vm._e(),(_vm.showTwoFactor)?_c('TwoFactor',{attrs:{"email":_vm.email,"password":_vm.password},on:{"LoginSuccess":_vm.loginSuccess}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }